module.exports = __webpack_public_path__ + "static/media/logo_ufms.cc77bcf8.png";